export default __webpack_public_path__ + "static/media/slide-02.a9fc4417.jpg";